import { render, staticRenderFns } from "./CreateCollectionModal.vue?vue&type=template&id=96522042&"
import script from "./CreateCollectionModal.vue?vue&type=script&lang=ts&"
export * from "./CreateCollectionModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports